import React, { ReactNode, useEffect } from 'react';
import { MiniKit } from '@worldcoin/minikit-js';
import { WORLDCOIN_APP_ID } from '../../config/app.config';

export default function MiniKitProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    MiniKit.install(WORLDCOIN_APP_ID);
  }, []);
  return <>{children}</>;
}
